import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import { EndPoints, getAuthHeader, getBaseUrl, getImageUrl, UploadType } from '../../api';
import { getConfig, update } from '../../api/config';
import { list } from '../../api/hygienes';
import { Button } from '../../components/Button';
import { HygieneItem } from '../../components/HygieneItem';
import { SpinnerBlock } from '../../components/Spinner';
import { HygienesDetailsModal } from './HygienesDetailsModal';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './hygienes.styl';
var HygienesView = /** @class */ (function (_super) {
    __extends(HygienesView, _super);
    function HygienesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hygienes: [],
            loading: false,
            showCreateModal: false,
            titleError: false,
            contentOneError: false,
            contentOneState: '',
            contentTwoError: false,
            contentTwoState: '',
            hygieneImageOneError: false,
        };
        _this.dropZoneOne = null;
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.createAction = function () {
            _this.setState({
                editHygiene: undefined,
                showCreateModal: true,
            });
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showCreateModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (model) {
            _this.setState({
                editHygiene: model,
                showCreateModal: true,
            });
        };
        _this.getUploadParams = function (_) {
            return {
                url: getBaseUrl() + EndPoints.upload + '?type=' + UploadType.hygiene,
                headers: getAuthHeader(),
            };
        };
        _this.handleChangeStatusOne = function (params, status) {
            if (status === 'done') {
                var response = JSON.parse(params.xhr.response);
                _this.setState({
                    hygieneImageOne: response.data.fileName,
                });
                _this.dropZoneOne.files = [];
            }
        };
        return _this;
    }
    HygienesView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    HygienesView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var contentOne = this.contentRefOne.getContent();
        if (isHtmlEmpty(contentOne)) {
            this.setState({ contentOneError: true });
            valid = false;
        }
        var contentTwo = this.contentRefTwo.getContent();
        if (isHtmlEmpty(contentTwo)) {
            this.setState({ contentTwoError: true });
            valid = false;
        }
        var hygieneImageOne = this.state.hygieneImageOne;
        if (!hygieneImageOne || hygieneImageOne.length === 0) {
            this.setState({ hygieneImageOneError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            hygieneContentOne: contentOne,
            hygieneContentTwo: contentTwo,
            hygieneImageOne: hygieneImageOne,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HygienesView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        list().then(function (result) {
            _this.setState({
                loading: false,
                hygienes: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
            });
            if (result) {
                _this.setState({
                    contentOneState: result.hygieneContentOne || '',
                    contentTwoState: result.hygieneContentTwo || '',
                    hygieneImageOne: result.hygieneImageOne || '',
                });
            }
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    HygienesView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var i18n = props.store.i18n;
        var _b = this.state, loading = _b.loading, hygienes = _b.hygienes, config = _b.config, contentOneState = _b.contentOneState, contentTwoState = _b.contentTwoState;
        return (React.createElement("div", { className: S.hygienesView },
            React.createElement("h1", { className: S.hygienesTitle }, i18n.hygienesTitle),
            React.createElement("hr", { className: S.hygienesSeparator }),
            React.createElement("div", { className: S.hygienesMainBox },
                React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleContent,
                            " #1"),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentRefOne = editor; }, apiKey: getEditorKey(), initialValue: contentOneState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentOneError ? 'inputErrorActive' : '') }, i18n.validationIndicationError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleIcon,
                            " #1"),
                        React.createElement("div", { className: "formUploadWrapper" },
                            state.hygieneImageOne ?
                                React.createElement("img", { className: "preview", src: getImageUrl(state.hygieneImageOne) })
                                :
                                    '',
                            React.createElement(Dropzone, { ref: function (r) { return _this.dropZoneOne = r; }, getUploadParams: this.getUploadParams, onChangeStatus: this.handleChangeStatusOne, multiple: false, inputContent: i18n.inputUploaderPlaceholder, canRestart: true, canCancel: false, canRemove: false, accept: "image/*" })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.hygieneImageOneError ? 'inputErrorActive' : '') }, i18n.validationImageError),
                        React.createElement("p", { className: "formSubtitle" },
                            i18n.inputTitleContent,
                            " #2"),
                        React.createElement(Editor, { onInit: function (_, editor) { return _this.contentRefTwo = editor; }, apiKey: getEditorKey(), initialValue: contentTwoState, init: getEditorOptions() }),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.contentOneError ? 'inputErrorActive' : '') }, i18n.validationIndicationError)),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.addButton, type: "submit", spinner: loading }, i18n.actionUpdate))),
            React.createElement("hr", { className: S.hygienesSeparator }),
            React.createElement("div", { className: S.hygienesHeaderActions },
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.hygienesMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.hygienesHeader },
                            React.createElement("div", { className: S.tableCell }, i18n.hygienesItemTitle),
                            React.createElement("div", { className: S.tableCell }, i18n.inputSubtitlePlaceholder),
                            React.createElement("div", { className: S.tableCell }, i18n.inputTitleColor),
                            React.createElement("div", { className: S.action }, i18n.hygienesAction)),
                        React.createElement("div", { className: S.hygienesUserList }, hygienes.map(function (hygiene, i) { return (React.createElement(HygieneItem, { key: i, hygiene: hygiene, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showCreateModal &&
                React.createElement(HygienesDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, hygiene: this.state.editHygiene })));
    };
    __decorate([
        action.bound
    ], HygienesView.prototype, "onSubmit", null);
    HygienesView = __decorate([
        inject('store'),
        observer
    ], HygienesView);
    return HygienesView;
}(React.Component));
export { HygienesView };
